export function formatDuration(minutes) {
  const total = Number(minutes) || 0;
  if (total <= 0) return "0m";
  const hours = Math.floor(total / 60);
  const mins = Math.round(total % 60);
  if (hours <= 0) return `${mins}m`;
  if (mins <= 0) return `${hours}h`;
  return `${hours}h ${mins}m`;
}

export function formatDurationSeconds(seconds) {
  const total = Number(seconds) || 0;
  if (total <= 0) return "00:00:00";
  const hrs = Math.floor(total / 3600)
    .toString()
    .padStart(2, "0");
  const mins = Math.floor((total % 3600) / 60)
    .toString()
    .padStart(2, "0");
  const secs = Math.floor(total % 60)
    .toString()
    .padStart(2, "0");
  return `${hrs}:${mins}:${secs}`;
}
